import { render, staticRenderFns } from "./preference-widget-tab.vue?vue&type=template&id=0b355f36"
import script from "./preference-widget-tab.vue?vue&type=script&lang=js"
export * from "./preference-widget-tab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports